import { Box } from "@mui/material";
import { LabCard } from "@insight-labs/card";
import { useEffect, useState, createElement } from "react";
import * as MuiIcons from "@mui/icons-material";

interface LocalCardDef {
  name: string;
  subtitle?: string;
  gradient?: [string, string];
  icon?: string;
  back?: string;
}

function hashCode(s: string): number {
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = ((hash << 5) - hash + s.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function getCardTransform(id: string) {
  const h = hashCode(id);
  return {
    rotate: ((h % 100) / 100) * 10 - 5,
    translateX: (((h >> 8) % 100) / 100) * 20 - 10,
    translateY: (((h >> 16) % 100) / 100) * 20 - 10,
  };
}

function resolveIcon(iconName: string | undefined) {
  if (!iconName) return undefined;
  const Icon = (MuiIcons as Record<string, unknown>)[iconName] as
    | React.ComponentType<{ sx?: Record<string, unknown> }>
    | undefined;
  if (!Icon) return undefined;
  return createElement(Icon, { sx: { fontSize: 48, color: "#fff" } });
}

export function LocalCardGrid() {
  const [cards, setCards] = useState<LocalCardDef[]>([]);

  useEffect(() => {
    fetch("/cards.json")
      .then((res) => (res.ok ? res.json() : { cards: [] }))
      .then((data) => setCards(data.cards || []))
      .catch(() => setCards([]));
  }, []);

  if (cards.length === 0) return null;

  return (
    <>
      {cards.map((card) => {
        const { rotate, translateX, translateY } = getCardTransform(card.name);
        return (
          <Box
            key={card.name}
            sx={{
              width: { xs: 160, sm: 204 },
              height: { xs: 254, sm: 324 },
              transform: `rotate(${rotate}deg) translate(${translateX}px, ${translateY}px)`,
              transition: "transform 0.3s ease, filter 0.3s ease, z-index 0s",
              filter: "drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15))",
              position: "relative",
              "&:hover": {
                transform: "rotate(0deg) translate(0, -8px) scale(1.05)",
                zIndex: 20,
                filter: "drop-shadow(0 12px 32px rgba(0, 0, 0, 0.3))",
              },
            }}
          >
            <LabCard
              name={card.name}
              subtitle={card.subtitle}
              gradient={card.gradient}
              icon={resolveIcon(card.icon)}
              back={card.back ? <p>{card.back}</p> : undefined}
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
        );
      })}
    </>
  );
}
